import logo from './images/logo_truong_uy.png'

const resource = {
    images: {logo},
    icons:{}
}
export default resource